/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Tag } from 'src/app/interfaces/api/category';

export type SidebarLink = {
  id: number;
  name: string;
  tags: Tag[];
  children?: SidebarLink[];
};

export type ActiveLink = {
  id: number;
  name: string;
  has_children: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class CategorySidebarService {
  private sidebarLinks = new BehaviorSubject<SidebarLink[]>([]);
  private activeLinkIds = new BehaviorSubject<ActiveLink[]>([]);
  private tags = new BehaviorSubject<Tag[]>([]);

  tags$ = this.tags.asObservable();
  activeLinkIds$ = this.activeLinkIds.asObservable();
  sidebarLinks$ = this.sidebarLinks.asObservable();

  constructor() {}

  setTags(tags: Tag[]) {
    this.tags.next(tags);
  }

  getTags(): Tag[] {
    return this.tags.getValue();
  }

  setActiveLinkIds(ids: ActiveLink[]) {
    // console.log('setting active link ids', ids);
    this.activeLinkIds.next(ids);
  }

  getActiveLinkIds(): ActiveLink[] {
    return this.activeLinkIds.getValue();
  }

  setSidebarLinks(links: SidebarLink[]) {
    this.sidebarLinks.next(links);
  }

  getSidebarLinks(): SidebarLink[] {
    return this.sidebarLinks.getValue();
  }

  findActiveLinks(navLinks: SidebarLink[], targetId: number): ActiveLink[] {
    // Recursive helper function to find path to target
    const findPath: (items: SidebarLink[], targetId: number, currentPath?: ActiveLink[]) => ActiveLink[] | null = (
      items,
      targetId,
      currentPath = [],
    ) => {
      for (const item of items) {
        // console.log(item.id, item.name);

        // Create a new path with current item's ID
        const newPath = [
          ...currentPath,
          {
            id: item.id,
            name: item.name,
            has_children: item.children && item.children.length > 0,
          },
        ];

        // If we found the target, return the path
        if (item.id === targetId) {
          // console.log(newPath);
          return newPath;
        }

        // If item has children, recursively search
        if (item.children && item.children.length > 0) {
          const childPath = findPath(item.children, targetId, newPath);
          if (childPath) {
            // console.log(childPath);
            return childPath;
          }
        }
      }

      // Target not found in this branch
      return null;
    };

    // Return the path or an empty array if not found
    return findPath(navLinks, targetId) || [];
  }
}
